import React from "react";
import { BrandMark } from "@/components/brand/BrandMark";

export const BrandLockup = ({
  className = "",
  compact = false,
  descriptor = "TEAM PORTAL",
  onClick,
  testId = "brand-lockup",
  variant = "dark",
}) => {
  return (
    <button
      className={`venuloq-brand-lockup ${compact ? "is-compact" : ""} ${className}`.trim()}
      data-testid={testId}
      onClick={onClick}
      type="button"
    >
      <span className="venuloq-brand-mark-wrap">
        <BrandMark size={compact ? 24 : 30} variant={variant} />
      </span>
      <span className="venuloq-brand-copy-wrap">
        <strong className="venuloq-brand-wordmark">VenuLoQ</strong>
        <span className="venuloq-brand-descriptor">{descriptor}</span>
      </span>
    </button>
  );
};
